<template>
  <!-- 项目一览 -->
  <div class="projectAllSee">
    <!-- 查询条件 -->
    <div class="queryCondition">
      <span style="margin-left: 0;">项目时间：</span>
      <el-date-picker v-model="projectDate" :picker-options="pickerOptions" type="daterange" size="small" align="right"
        start-placeholder="开始月份" range-separator="至" end-placeholder="结束月份" unlink-panels>
      </el-date-picker>
      <span>项目类型：</span>
      <el-select v-model="projectType" size="small" clearable placeholder="请选择">
        <el-option v-for="item in types" :key="item.dicId" :label="item.cnName" :value="item.dicId">
        </el-option>
      </el-select>
      <span>项目等级：</span>
      <el-select v-model="projectLevel" size="small" clearable placeholder="请选择">
        <el-option v-for="item in levels" :key="item.dicId" :label="item.cnName" :value="item.dicId">
        </el-option>
      </el-select>
      <span>项目总建筑面积：</span>
      <el-input v-model="minArea" placeholder="最小面积值" size="small" type="number" style="width: 140px" :min="0"
        :max="maxArea || 999999999" @change="filterMinArea"></el-input>
      <span style="margin: 0 8px">-</span>
      <el-input v-model="maxArea" placeholder="最大面积值" size="small" type="number" style="width: 140px" :min="minArea || 0"
        :max="999999999" @change="filterMaxArea"></el-input>

      <el-button size="small" style="margin-left: 20px;" plain @click="reset">重置</el-button>
      <el-button size="small" type="primary" @click="search">查询</el-button>
    </div>

    <!-- 项目区域 -->
    <div class="projectRegion">
      <span>项目区域：</span>
      <div class="regions">
        <el-button type="primary" size="small" :plain="region !== ''" @click="region = ''">全部</el-button>
        <el-button type="primary" size="small" :plain="region !== '0'" @click="region = '0'">无区域</el-button>
        <el-button v-for="item in cityRegions" :key="item.code" type="primary" size="small" :plain="region !== item.code"
          @click="region = item.code">
          {{ item.name }}
        </el-button>

        <div v-if="!regionOpen && prjAreaList.length > 6" class="Btn" @click="regionOpen = true">
          <span>展开</span>
          <i class="el-icon-arrow-down"></i>
        </div>
        <div v-if="regionOpen" class="Btn" @click="regionOpen = false">
          <span>收起</span>
          <i class="el-icon-arrow-up"></i>
        </div>
      </div>
    </div>

    <!-- 地区图 -->
    <div class="regionBoard">
      <el-tag type="info" effect="plain">
        <div v-if="region == ''" class="text_up">{{ totalNum + invalidTotalNum }}</div>
        <div v-if="region == '0'" class="text_up">{{ invalidTotalNum }}</div>
        <div v-if="region != '' && region != '0'" class="text_up">{{ totalNum }}</div>
        <div class="text_down">项目总数</div>
      </el-tag>
      <div id="regionChart" ref="regionChart" class="regionSlider"></div>
    </div>

    <!-- 承接部门项目数排名 -->
    <div class="title">
      <el-divider direction="vertical"></el-divider>
      <span>承接部门项目数排名</span>
    </div>
    <div class="departBoard">
      <!-- 承接部门图 -->
      <div id="departChart" ref="departChart" class="departSlider"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import dataBoardService from "@/CommonDP/service/dataBoard-service.js";
import dicService from "@/CommonDP/service/dic-service.js";
import moment from "moment";
import chinaMap from "@/CommonDP/commons/map";
import regions from "@/CommonDP/commons/region";
import * as echarts from 'echarts';
var regionChart; // 地区图
var departChart; // 承接部门图

export default {
  components: {},
  data() {
    return {
      types: [], // 类型
      levels: [], // 等级
      region: "", // 项目区域
      regionOpen: false, // 项目区域展开

      projectDate: [], // 选择项目时间
      projectType: "", // 项目类型
      projectLevel: "", // 项目等级
      maxArea: null, // 最大面积
      minArea: null, // 最小面积

      prjAreaList: [], // 项目区域数据
      deptPrjNum: [], // 部门承接项目数排名数据

      pickerOptions: {
        // 日期选择快捷键
        shortcuts: [
          {
            text: "近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),

    // 城市区域
    cityRegions() {
      let provinces = this.prjAreaList;
      provinces = provinces.filter((item) => item.name);
      provinces = provinces.map((item) => {
        const city = { ...item };
        let name = item.name;
        name = name.replace("市", "");
        city.name = name;
        return city;
      });
      if (!this.regionOpen && this.prjAreaList.length > 6) {
        return provinces.slice(0, 6);
      } else {
        return provinces;
      }
    },

    // 开始时间
    startDate() {
      if (this.projectDate && this.projectDate.length > 0) {
        return moment(this.projectDate[0]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },
    // 结束时间
    endDate() {
      if (this.projectDate && this.projectDate.length > 1) {
        return moment(this.projectDate[1]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },
    // 地图--省份数据
    provinces() {
      let data = this.prjAreaList.map((item) => {
        return { cname: item.name, value: item.prjNum, code: item.code };
      });
      // 区域筛选
      if (this.region) {
        data = data.filter((item) => {
          return item.code === this.region;
        });
      }

      const provinces = [];
      regions.forEach((item) => {
        // 省
        const province = {};
        let name = item.label.replace("省", "");
        name = name.replace("自治区", "");
        name = name.replace("壮族", "");
        name = name.replace("回族", "");
        name = name.replace("维吾尔", "");
        let value = 0;
        const city = [];
        item.children.forEach((ite) => {
          // 市
          data.forEach((area) => {
            if (area.cname === ite.label) {
              value += area.value;
              city.push(area);
            }
          });
        });
        province.name = name;
        province.value = value;
        province.city = city;
        provinces.push(province);
      });
      return provinces;
    },

    // 项目总数
    totalNum() {
      let num = 0;
      this.provinces.forEach((item) => {
        item.city.forEach((item2) => {
          num += item2.value;
        });
      });
      return num;
    },

    // 无效项目数(不存在位置)
    invalidTotalNum() {
      let data = this.prjAreaList.map((item) => {
        return { cname: item.name, value: item.prjNum, code: item.code };
      });
      data = data.filter((item) => !item.cname);
      let num = 0;
      data.forEach((item) => {
        num += item.value;
      });
      return num;
    }
  },
  watch: {
    region() {
      this.setOption();
      this.departChart_setOption();
    },
    prjAreaList() {
      this.region = "";
      this.regionOpen = false;
    }
  },
  mounted() {
    this.getPrjTypeAndLevel();
    this.regionChart_init();
    this.departChart_init();
  },
  methods: {
    // 获得项目类型和项目等级
    async getPrjTypeAndLevel() {
      // 获得项目类型
      const res1 = await dicService.getDicList("PrjType");
      this.types = res1.data;
      // 获得项目等级
      const res2 = await dicService.getDicList("PrjLevel");
      this.levels = res2.data;
    },
    // 过滤最小面积
    filterMinArea() {
      const list = this.minArea.split(".");
      this.minArea = list[0];
      if (this.minArea > 999999999) this.minArea = 999999999;
      if (this.minArea < 0) this.minArea = 0;
    },
    // 过滤最大面积
    filterMaxArea() {
      const list = this.maxArea.split(".");
      this.maxArea = list[0];
      if (this.maxArea > 999999999) this.maxArea = 999999999;
      if (this.maxArea < 0) this.maxArea = 0;
    },

    // 查询项目区域+区域内项目数量
    async getPrjAreaList() {
      const params = {
        enterpriseId: this.enterpriseId,
        startDate: this.startDate, // 开始时间
        endDate: this.endDate, // 结束时间
        grossFloorAreaMax: this.maxArea, // 总建筑面积-大
        grossFloorAreaMin: this.minArea, // 总建筑面积-小
        prjCategoryId: this.projectType, // 项目类型
        prjLevelId: this.projectLevel // 项目等级
      };
      const res = await dataBoardService.getPrjAreaList(params);
      this.prjAreaList = res.data;
    },

    // 地区图_初始化
    regionChart_init() {
      regionChart = echarts.init(this.$refs.regionChart);
      echarts.registerMap("china", chinaMap);
      this.regionChart_setOption();
    },

    // 地区图_加载数据
    regionChart_setOption() {
      this.getPrjAreaList().then(() => {
        this.setOption();
      });
    },

    // 不请求数据，重新加载
    setOption() {
      const option = {
        title: {
          text: "项目热度",
          top: "34%",
          left: "90%",
          textStyle: {
            fontFamily: "PingFang SC",
            fontSize: 14,
            fontWeight: "bold",
            color: "#666666"
          }
        },
        // 分段图例
        visualMap: {
          type: "piecewise",
          left: "90%",
          y: "center",
          align: "left",
          pieces: [
            // 根据数据大小，各省显示不同颜色
            { min: 20 },
            { min: 16, max: 20 },
            { min: 11, max: 15 },
            { min: 6, max: 10 },
            { min: 1, max: 5 },
            { min: 0, max: 0 }
          ],
          inRange: {
            symbol: "rect",
            color: ["#e4f0fd", "#1f307b"]
          }
        },
        series: [
          {
            type: "map",
            map: "china",
            layoutCenter: ["49%", "50%"], // 地图位置
            layoutSize: "100%",
            zoom: 1.2,
            itemStyle: {
              areaColor: "#e4f0fd"
            },
            data: this.provinces,
            // 高亮显示
            emphasis: {
              disabled: false
            }
          }
        ],
        // 提示
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0, 0, 0, 0.62)",
          padding: [10, 30, 10, 10],
          borderWidth: 0,
          textStyle: {
            fontFamily: "PingFang SC",
            fontSize: 14,
            color: "#ffffff"
          },
          extraCssText: "line-height: 24px",
          axisPointer: {
            type: "shadow"
          },
          formatter(e) {
            let result = e.marker + " " + e.name;
            let city = [];
            if (e.data) {
              city = e.data.city;
            }
            if (city.length > 0) {
              city.forEach((item) => {
                result = result + "<br>" + "&nbsp;&nbsp;&nbsp;&nbsp;" + item.cname + "：" + item.value;
              });
            }
            return result;
          }
        }
      };
      regionChart.setOption(option, true);
    },

    // 重置
    reset() {
      this.projectDate = []; // 选择项目时间
      this.projectType = ""; // 项目类型
      this.projectLevel = ""; // 项目等级
      this.maxArea = null; // 最大面积
      this.minArea = null; // 最小面积
    },

    // 查询
    search() {
      this.regionChart_setOption();
      this.departChart_setOption();
    },

    // 获得部门承接项目数排名
    async getDeptPrjNum() {
      const params = {
        enterpriseId: this.enterpriseId,
        cityCode: this.region, // 城市编码
        startDate: this.startDate, // 开始时间
        endDate: this.endDate, // 结束时间
        grossFloorAreaMax: this.maxArea, // 总建筑面积-大
        grossFloorAreaMin: this.minArea, // 总建筑面积-小
        prjCategoryId: this.projectType, // 项目类型
        prjLevelId: this.projectLevel // 项目等级
      };
      const res = await dataBoardService.getDeptPrjNumDashboard(params);
      this.deptPrjNum = res.data;
    },

    // 承接部门图_初始化
    departChart_init() {
      departChart = echarts.init(this.$refs.departChart);
      this.departChart_setOption();
    },

    // 承接部门图_加载数据
    departChart_setOption() {
      this.getDeptPrjNum().then(() => {
        const x_dept = this.deptPrjNum.map((item) => item.deptName);
        const prjNum = this.deptPrjNum.map((item) => item.prjNum);
        const option = {
          // x轴
          xAxis: [
            {
              type: "category",
              offset: 6,
              data: x_dept,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#DCDCDC"
                }
              }, // 轴线
              axisLabel: { color: "#646464" }, // 标签
              axisTick: {
                show: false
              } // 刻度
            }
          ],
          // y轴
          yAxis: {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#DCDCDC"
              }
            }, // 轴线
            axisLabel: { color: "#646464" }, // 标签
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#F5F5F5"
              }
            } // 分割线
          },
          // 坐标轴定位
          grid: {
            top: "10%",
            width: "100%",
            left: "0",
            containLabel: true
          },
          // 滚动滑块
          dataZoom: [
            {
              startValue: 0,
              endValue: 9,
              zoomLock: false, // 锁定滑块大小
              handleSize: 6,
              showDetail: false, // 滑块两端信息
              showDataShadow: false, // 数据阴影可以简单地反应数据走势
              brushSelect: false,
              show: true,
              height: 6,
              right: 6,
              backgroundColor: "rgba(220, 220, 220, 0.3)", // 背景颜色
              borderColor: "rgb(0 0 0 0.3);", // 边框颜色
              fillerColor: "rgba(200, 200, 200, 0.88)", // 滑块颜色
              handleIcon: "circle", // 滑块两端圆形
              handleStyle: {
                color: "rgba(200, 200, 200, 1)", // 滑块两端圆形颜色
                borderWidth: 0
              }
            }
          ],
          // 列表
          series: [
            {
              name: "项目数",
              type: "bar",
              barWidth: 25, // 柱图宽度
              data: prjNum
            }
          ],
          // 提示
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(0, 0, 0, 0.62)",
            padding: [15, 20, 15, 15],
            borderWidth: 0,
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              color: "#ffffff"
            },
            extraCssText: "line-height: 24px",
            axisPointer: {
              type: "shadow"
            }
          }
        };
        if (x_dept.length < 11) option.dataZoom = [];
        departChart.setOption(option, true);
      });
    },

    // 导出PPT
    async exportPPT() {
      let total = ""; // 地图左边项目总数
      if (this.region == "") total = this.totalNum + this.invalidTotalNum;
      else if (this.region == "0") total = this.invalidTotalNum;
      else total = this.totalNum;

      const params = {
        dashboard: 1, // 项目一览固定 1
        condition: {
          enterpriseId: this.enterpriseId,
          cityCode: this.region,
          startDate: this.startDate,
          endDate: this.endDate,
          grossFloorAreaMax: this.maxArea,
          grossFloorAreaMin: this.minArea,
          prjCategoryId: this.projectType,
          prjLevelId: this.projectLevel
        }, // 顶部查询条件
        slideList: [
          {
            total,
            chartBase64List: ["{{" + this.createBase64("#regionChart") + "}}"] // 地图图表base64
          },
          {
            chartBase64List: ["{{" + this.createBase64("#departChart") + "}}"] // 承接部门项目数排名图表base64
          }
        ]
      };
      const res = await dataBoardService.exportPPT(params);
      const fileName = "项目一览.pptx";
      if ("msSaveOrOpenBlob" in navigator) {
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    // echarts图表转化为base64
    createBase64(ele) {
      const docEle = ele + " canvas";
      const canvasFixed = document.querySelector(docEle); // 获取图表元素
      const canvasWidth = canvasFixed.width; // 获取图表元素宽度
      const canvasHeigth = canvasFixed.heigth; // 获取图表元素高度
      const canvas2D = canvasFixed.getContext("2d");
      canvas2D.drawImage(canvasFixed, canvasWidth, canvasHeigth);
      return canvasFixed.toDataURL();
    },
    // 导出excel
    async exportExcel() {
      const params = {
        dashboard: 1, // 项目一览固定 1
        condition: {
          enterpriseId: this.enterpriseId,
          cityCode: this.region,
          startDate: this.startDate,
          endDate: this.endDate,
          grossFloorAreaMax: this.maxArea,
          grossFloorAreaMin: this.minArea,
          prjCategoryId: this.projectType,
          prjLevelId: this.projectLevel
        } // 顶部查询条件
      };
      const res = await dataBoardService.exportExcel(params);
      const fileName = "项目一览.xlsx";
      if ("msSaveOrOpenBlob" in navigator) {
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.projectAllSee {
  width: 100%;
  height: 100%;
  padding: var(--big-space);
  border-radius: 0 0 4px 4px;
  background-color: white;
  overflow-y: auto;

  .projectRegion {
    width: 100%;
    padding: var(--middle-space) 0;
    display: flex;

    span {
      line-height: 40px;
      font-size: 14px;
      font-weight: 400;
      font-family: "Microsoft YaHei UI";
      color: var(--key-color);
    }

    .regions {
      width: calc(100% - 80px);
      display: flex;
      align-items: center;
      flex-flow: wrap;

      .el-button {
        padding: 7px 18px;
        border: none;
        margin: 5px 0;
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 14px;
      }

      /deep/ .el-button--primary.is-plain {
        background: #eef3fd !important;
        color: #4777e7 !important;
      }

      .Btn {
        margin-left: 20px;
        white-space: nowrap;
        cursor: pointer;
        display: flex;
        align-items: center;

        span {
          color: var(--theme-color);
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 14px;
          line-height: 28px;
        }

        i {
          padding: 0 4px;
          color: var(--theme-color);
        }
      }
    }
  }

  .queryCondition {
    width: 100%;
    display: flex;
    align-items: center;

    span {
      font-family: "Microsoft YaHei UI";
      font-weight: 400;
      font-size: 14px;
      line-height: 28px;
      color: var(--key-color);
      white-space: nowrap;
      margin-left: var(--middle-space);
    }
  }

  .regionBoard {
    width: 100%;
    padding: var(--small-space) 0;
    position: relative;
    display: flex;
    justify-content: center;

    .el-tag {
      position: absolute;
      left: 10%;
      top: 40%;
      z-index: 10;
      width: 180px;
      height: 100px;
      padding: 20px 0;
      background: #edf1fc;
      border-radius: 8px;
      border: none;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;

      .text_up {
        font-family: "GeoSlab703 Md BT";
        font-weight: 400;
        font-size: 30px;
        color: #5592ff;
        white-space: nowrap;
      }

      .text_down {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #5592ff;
        white-space: nowrap;
      }
    }

    .regionSlider {
      width: 1200px;
      height: 640px;
    }
  }

  .departBoard {
    width: 100%;
    padding: var(--middle-space) 0;
    display: flex;
    justify-content: center;

    .departSlider {
      width: 1400px;
      height: 320px;
    }
  }
}

/deep/.el-range-separator {
  width: max-content;
}

.title {
  width: 100%;
  padding: var(--middle-space) 0;
  display: flex;
  align-items: center;

  .el-divider {
    background-color: var(--theme-color);
    width: 3px;
    height: 15px;
    margin: 0 8px;
  }

  span {
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    color: var(--key-color);
    white-space: nowrap;
  }
}
</style>
